/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { PutApiPolicyMutationRequest, PutApiPolicyMutationResponse, PutApiPolicy400, PutApiPolicy401, PutApiPolicy403, PutApiPolicy404, PutApiPolicy500 } from "../../types/PutApiPolicy.ts";
import { putApiPolicyMutationResponseSchema, putApiPolicyMutationRequestSchema } from "../../zod/PolicySchemas/putApiPolicySchema.ts";

function getPutApiPolicyUrl() {
  const res = { method: 'PUT', url: `/api/policy` as const }  
  return res
}

/**
 * @summary Обновление политики
 * {@link /api/policy}
 */
export async function putApiPolicy({ data }: { data?: PutApiPolicyMutationRequest }, config: Partial<RequestConfig<PutApiPolicyMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = putApiPolicyMutationRequestSchema.parse(data)  
  
  const res = await request<PutApiPolicyMutationResponse, ResponseErrorConfig<PutApiPolicy400 | PutApiPolicy401 | PutApiPolicy403 | PutApiPolicy404 | PutApiPolicy500>, PutApiPolicyMutationRequest>({ method : "PUT", url : getPutApiPolicyUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/*+json', ...requestConfig.headers } })  
  return putApiPolicyMutationResponseSchema.parse(res.data)
}